"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayerImages = exports.getVehicleSource = void 0;
/* eslint-disable */
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../icons");
var common_1 = require("./common");
var getVehicleSource = function (_a) {
    var points = _a.points, onClick = _a.onClick;
    var vehicles = points;
    return {
        layers: [
            {
                data: {
                    id: "vehicle",
                    type: "symbol",
                    source: "vehicles",
                    layout: {
                        "icon-image": ["get", "image-icon"],
                        "icon-rotate": ["get", "icon-rotation"],
                        "icon-size": 1,
                    },
                    filter: ["!", ["has", "point_count"]],
                },
                onClick: function (e, map) {
                    var _a, _b, _c, _d;
                    // @ts-ignore
                    var features = map.queryRenderedFeatures(e.point, {
                        layers: ["vehicles"],
                    });
                    // @ts-ignore
                    var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                    map.easeTo({
                        center: center,
                    });
                    if (onClick) {
                        onClick((_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                    }
                },
                onMouseEnter: function (e, map) {
                    map.getCanvas().style.cursor = "pointer";
                },
                onMouseLeave: function (e, map) {
                    map.getCanvas().style.cursor = "";
                },
            },
        ],
        sourceId: "vehicles",
        source: {
            type: "geojson",
            generateId: true,
            data: {
                type: "FeatureCollection",
                features: vehicles.map(function (vehicle) {
                    var _a, _b;
                    var rotation = 360;
                    if (!vehicle.rotation) {
                        rotation = 0;
                    }
                    else {
                        rotation = vehicle.rotation;
                    }
                    return {
                        type: "Feature",
                        properties: {
                            id: vehicle.id,
                            "image-icon": "vehicle-marker-" + vehicle.id,
                            "icon-rotation": rotation,
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                (_a = vehicle.location) === null || _a === void 0 ? void 0 : _a.longitude,
                                (_b = vehicle.location) === null || _b === void 0 ? void 0 : _b.latitude,
                            ],
                        },
                    };
                }),
            },
        },
        images: exports.getLayerImages(vehicles),
    };
};
exports.getVehicleSource = getVehicleSource;
var getLayerImages = function (vehicles) {
    return vehicles.map(function (vehicle) { return ({
        name: "vehicle-marker-" + vehicle.id,
        image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.VehicleMarker, { color: vehicle.color, size: common_1.IMAGE_SIZE }); }, 21 * common_1.IMAGE_SCALE, 22 * common_1.IMAGE_SCALE),
        external: false,
    }); });
};
exports.getLayerImages = getLayerImages;
